import {
  GET_ICONS,
  GET_ICONS_FAILED,
  GET_ICONS_SUCCESS,
  GET_PLATFORM_SETTINGS,
  GET_PLATFORM_SETTINGS_FAILED,
  GET_PLATFORM_SETTINGS_SUCCESS,
  GET_SOCIAL_PROFILE_SETTINGS,
  GET_SOCIAL_PROFILE_SETTINGS_FAILED,
  GET_SOCIAL_PROFILE_SETTINGS_SUCCESS,
  GET_WEBSITE_CONFIGS,
  GET_WEBSITE_CONFIGS_FAILED,
  GET_WEBSITE_CONFIGS_SUCCESS,
  UPDATE_PLATFORM_SETTINGS,
  UPDATE_PLATFORM_SETTINGS_FAILED,
  UPDATE_PLATFORM_SETTINGS_SUCCESS,
  UPDATE_SOCIAL_PROFILE_SETTINGS,
  UPDATE_SOCIAL_PROFILE_SETTINGS_FAILED,
  UPDATE_SOCIAL_PROFILE_SETTINGS_SUCCESS,
  UPDATE_WEBSITE_CONFIGS,
  UPDATE_WEBSITE_CONFIGS_FAILED,
  UPDATE_WEBSITE_CONFIGS_SUCCESS,
} from "./actionTypes"

export const getPlatformSettings = params => ({
  type: GET_PLATFORM_SETTINGS,
  payload: params,
})

export const getPlatformSettingsSuccess = response => ({
  type: GET_PLATFORM_SETTINGS_SUCCESS,
  payload: response,
})

export const getPlatformSettingsFailed = error => ({
  type: GET_PLATFORM_SETTINGS_FAILED,
  payload: error,
})

export const updatePlatformSettings = params => ({
  type: UPDATE_PLATFORM_SETTINGS,
  payload: params,
})

export const updatePlatformSettingsSuccess = response => ({
  type: UPDATE_PLATFORM_SETTINGS_SUCCESS,
  payload: response,
})

export const updatePlatformSettingsFailed = error => ({
  type: UPDATE_PLATFORM_SETTINGS_FAILED,
  payload: error,
})

export const getIcons = () => ({
  type: GET_ICONS,
  payload: {},
})

export const getIconsSuccess = response => ({
  type: GET_ICONS_SUCCESS,
  payload: response,
})

export const getIconsFailed = error => ({
  type: GET_ICONS_FAILED,
  payload: error,
})

export const getSocialProfileSettings = params => ({
  type: GET_SOCIAL_PROFILE_SETTINGS,
  payload: params,
})

export const getSocialProfileSettingsSuccess = response => ({
  type: GET_SOCIAL_PROFILE_SETTINGS_SUCCESS,
  payload: response,
})

export const getSocialProfileSettingsFailed = error => ({
  type: GET_SOCIAL_PROFILE_SETTINGS_FAILED,
  payload: error,
})

export const updateSocialProfileSettings = params => ({
  type: UPDATE_SOCIAL_PROFILE_SETTINGS,
  payload: params,
})

export const updateSocialProfileSettingsSuccess = response => ({
  type: UPDATE_SOCIAL_PROFILE_SETTINGS_SUCCESS,
  payload: response,
})

export const updateSocialProfileSettingsFailed = error => ({
  type: UPDATE_SOCIAL_PROFILE_SETTINGS_FAILED,
  payload: error,
})

export const getWebsiteConfigs = params => ({
  type: GET_WEBSITE_CONFIGS,
  payload: params,
})

export const getWebsiteConfigsSuccess = response => ({
  type: GET_WEBSITE_CONFIGS_SUCCESS,
  payload: response,
})

export const getWebsiteConfigsFailed = error => ({
  type: GET_WEBSITE_CONFIGS_FAILED,
  payload: error,
})

export const updateWebsiteConfigs = params => ({
  type: UPDATE_WEBSITE_CONFIGS,
  payload: params,
})

export const updateWebsiteConfigsSuccess = response => ({
  type: UPDATE_WEBSITE_CONFIGS_SUCCESS,
  payload: response,
})

export const updateWebsiteConfigsFailed = error => ({
  type: UPDATE_WEBSITE_CONFIGS_FAILED,
  payload: error,
})
